<div id="content" class="allcp-form" ng-controller="WorkTypeController" ng-init="all()">
<div ng-include="'modules/company/menus/order_menu.html'"></div>
    <div class="row mt20">

        <div class="col-md-6">
            <div class="panel">

                <div class="panel-heading">
                    <span class="panel-title"> Kargo Türleri</span>
                    <hr>
                </div> 

                <div class="panel-body mn pn">

                    <div class="row m10" ng-repeat="item in data.workTypes">
                        <div class="col-md-9 work-steps">
                            <strong class="ml10" ng-style="{'color': item.color }">{{ item.name }}</strong>
                            <span class="desc" ng-if="item.sms_send == 1">
                                <span>{{ item.sms.content }}</span>
                            </span>
                        </div>

                        <div class="col-md-3 mt20">
                            <a href="#" style="color:#8da2b3;margin-right:10px;" ng-click="editType(item)"> Düzenle </a>
                            <a href="#" style="color:#8da2b3;" ng-click="deleteType(item.id,'set')"> Sil</a>
                        </div>
                    </div>
                    
                    <div class="row">
                        <div class="col-md-9 pr10">
                        <a href="#" ng-click="newType()" class="btn btn-success btn-block">
                            <i class="fa fa-plus"></i> Yeni Kargo Tipi Ekle
                        </a>
                        </div>
                    </div>
                </div>

            </div>
        </div>
        
        <div class="modal right fade" id="newType" tabindex="-1" role="dialog" aria-labelledby="newTypeLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h5 class="modal-title"> 
                        <strong ng-if="workType.id"> KargoTipi Düzenle</strong>
                        <strong ng-if="!workType.id"> Yeni Kargo Tipi Ekle</strong>
                    </h5>
                </div>
                <form ng-submit="save()" class="form-horizontal allcp-form">
                <div class="modal-body">
                    <div class="form-group">
                        <label class="col-md-3 control-label">KargoTip Adı * : </label>
                        <div class="col-md-9">
                            <label for="name21" class="field prepend-icon">
                                <input type="text" ng-model="workType.name" class="gui-input br-light light" placeholder="KargoTipi Adı" required>
                                <label for="name21" class="field-icon">
                                    <i class="fa fa-list-alt"></i>
                                </label>
                            </label>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
                    <button type="submit" class="btn btn-primary" ng-if="!workType.id">Ekle</button>
                    <button type="submit" class="btn btn-warning" ng-if="workType.id">Güncelle</button>
                </div>
                </form>
                
                </div>
            </div>
        </div>    

        <div class="modal fade" id="delete" tabindex="-1" role="dialog" aria-labelledby="deleteLabel">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h5 class="modal-title"> <strong> Dikkat!</strong></h5>
                </div>
                <div class="modal-body">
                    <strong class="text-danger">
                        <i class="fa fa-exclamation-triangle"></i> Yapacağınız silme işlemi geri alınamaz bir işlemdir.
                    </strong>
                    <p><strong>Silmek istediğinizden emin misiniz ? </strong> </p>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default" data-dismiss="modal">Vazgeç</button>
                    <button type="button" class="btn btn-danger" ng-click="deleteType('','delete')" data-dismiss="modal">Sil</button>
                </div>
                </div>
            </div>
        </div>
    </div>
</div>
    